"use client";

import {
	type DefaultImageProps,
	type DefaultLinkProps,
	Image,
	type ImageProps,
	Link,
	type LinkProps
} from "@pamperedchef/design-system";
import * as styles from "./LogoHeader.module.scss";

export interface LogoHeaderProps<ImageComponentProps = DefaultImageProps> {
	logo: ImageProps<ImageComponentProps>;
	logoLink: LinkProps<DefaultLinkProps>;
}

export function LogoHeader<ImageComponentProps = DefaultImageProps>({
	logo,
	logoLink
}: LogoHeaderProps<ImageComponentProps>): JSX.Element {
	return (
		<header className={styles.header}>
			<div className="container">
				<div className={styles["logo-container"]}>
					<Link<DefaultLinkProps>
						{...logoLink}
						className={styles.logo}
					>
						<Image<ImageComponentProps>
							className={styles["logo-image"]}
							{...logo}
							alt={logo.alt || ""}
						/>
					</Link>
				</div>
			</div>
		</header>
	);
}
